import { Component, ContentChildren, Directive, Input, OnInit, QueryList, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { getDisplayFormats } from 'src/app/decorator/display-format.decorator';

@Component({
    selector: 'app-generic-table',
    templateUrl: './generic-table.component.html',
    providers: [DatePipe]
})
export class GenericTableComponent implements OnInit {

    @Input() items: any[] = [];
    @Input() includes?: string[];
    @Input() excludes?: string[];

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    columns: string[] = [];
    metadata: Record<string, any> = {};
    dataSource: MatTableDataSource<any> = new MatTableDataSource();

    constructor(private datePipe: DatePipe, private translate: TranslateService) { }

    ngOnInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items'] && this.items) {
            this.updateColumns();
            const proto = Object.getPrototypeOf(this.items[0]);
            this.metadata = getDisplayFormats(proto);

            this.dataSource.data = this.items;
        }
    }

    updateColumns() {
        // items[0]がある場合にカラム名を取得、それ以外は空の配列
        const keys = this.items.length > 0 ? Object.keys(this.items[0]) : [];
        let filteredColumns = keys;

        // 必要なカラムをフィルタリング
        if (this.includes) {
            filteredColumns = filteredColumns.filter(col => this.includes!.includes(col));
        }
        if (this.excludes) {
            filteredColumns = filteredColumns.filter(col => !this.excludes!.includes(col));
        }

        // 追加カラムを統合
        this.columns = [...filteredColumns];
    }

    getLabel(key: string): string {
        const meta = this.metadata[key];
        if (meta?.translationKey) {
            const translated = this.translate.instant(meta.translationKey);
            if (translated && translated !== meta.translationKey) return translated;
        }
        return meta?.label || key;
    }

    formatValue(value: any, key: string): any {
        const meta = this.metadata[key];
        switch (meta?.type) {
            case 'date':
                return this.datePipe.transform(value, meta.format || 'yyyy-MM-dd');
            case 'boolean':
                return value ? '✔️' : '✖️';
            default:
                return value;
        }
    }
}
